export class AddressUtilities {
    static compileCityStateZip(city, state, zip) {
        const cityText = city ? `${city}, ` : '';
        const stateText = state ? `${state} ` : '';
        return `${cityText}${stateText}${zip || ''}`.trim();
    }
}
